import { render, staticRenderFns } from "./RegistroNaoConformidade.vue?vue&type=template&id=ef84056e&scoped=true&"
import script from "./RegistroNaoConformidade.vue?vue&type=script&lang=js&"
export * from "./RegistroNaoConformidade.vue?vue&type=script&lang=js&"
import style0 from "./RegistroNaoConformidade.vue?vue&type=style&index=0&id=ef84056e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef84056e",
  null
  
)

export default component.exports